import axios from 'axios'

export default {
  data() {
    return {
      users: [],
      search: null,
      totalCount: 0,
      perPage: 10,
      currentPage: 1,
      upcomingWfh: [],
      todayWfh: [],
      emp_ids: [],
    }
  },

  computed: {
    appState() {
      return this.$store.state.app
    },
  },

  watch: {
    currentPage() {
      this.getupComingWfhList()
    },
  },

  mounted() {
    this.getEmployeeIds()
  },

  methods: {
    async getEmployeeIds() {
      if (this.userInfo && this.userInfo.role === 'HR') {
        this.emp_ids = ['all']
        this.getupComingWfhList()
        this.getTodayWfhList()
      } else {
        const response = await this.getHTTPPostResponse(
          'project/user/list',
          {},
          false,
        )
        if (response && response.data) {
          const { data } = response
          this.emp_ids = data.employee_ids
          if (this.emp_ids && this.emp_ids.length > 0) {
            this.getupComingWfhList()
            this.getTodayWfhList()
          }
        }
      }
    },

    async getupComingWfhList() {
      const input = {
        sort_field: 'date',
        sort_order: 'asc',
        emp_id: this.emp_ids,
        type: 'upcoming',
        redis_key: this.appState.redisKey,
      }

      const url = `${process.env.VUE_APP_HRMS_SERVICE_URL}track-user-wfh`
      await axios
        .post(url, input, {
          headers: {
            redisKey: this.appState.redisKey,
            authToken: this.appState.authToken,
          },
        })
        .then(response => {
          this.upcomingWfh = response.data.data.remote_works
        })
        .catch(error => {
          console.error('There was an error fetching upcoming WFH!', error)
        })
    },

    async getTodayWfhList() {
      const input = {
        sort_field: 'date',
        sort_order: 'asc',
        emp_id: this.emp_ids,
        type: 'today',
        redis_key: this.appState.redisKey,
      }

      const url = `${process.env.VUE_APP_HRMS_SERVICE_URL}track-user-wfh`
      await axios
        .post(url, input, {
          headers: {
            redisKey: this.appState.redisKey,
            authToken: this.appState.authToken,
          },
        })
        .then(response => {
          this.todayWfh = response.data.data.todays_remote_works
        })
        .catch(error => {
          console.error('There was an error fetching today WFH!', error)
        })
    },
  },
}
